import React from "react";
import "./Header.css";

function Header() {
  const PHONE_E164 = "+17622154738";
  const STREET = "3355 Deans Bridge Rd Ste D";
  const CITY = "Augusta";
  const STATE = "GA";
  const ZIP = "30906";

  const mapsQuery = encodeURIComponent(
    `${STREET}, ${CITY}, ${STATE} ${ZIP}`
  );

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${mapsQuery}`;

  return (
    <header className="site-header">
      <nav className="navbar" aria-label="Primary navigation">
        <div className="navbar-inner">
          <a href="/" className="brand-link" aria-label="Big Pace Barber Shop 2 home">
            <span className="brand-mark" aria-hidden="true">
              💈
            </span>

            <span className="brand-text">
              <span className="brand-name">Big Pace</span>
              <span className="brand-subtitle">Barber Shop & Beauty Salon 2</span>
            </span>
          </a>

          <div className="navbar-actions">
            <a
              className="navbar-link navbar-call"
              href={`tel:${PHONE_E164}`}
              aria-label="Call Big Pace Barber Shop and Beauty Salon 2"
            >
              Call
            </a>

            <a
              className="navbar-link navbar-directions"
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get directions to Big Pace Barber Shop and Beauty Salon 2"
            >
              Directions
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;